import { Logger } from '@west-australian-newspapers/typescript-log'
import {
    loadRrmeOfferGroupFromApi,
    offerGroups,
} from '../../subscription-offers/SubscriptionOffers'

export async function initSubscriptionOffers(
    publicationId: string,
    log: Logger,
    isSSR: boolean,
    variant?: string,
    config?: { subscriptionOfferApi?: string },
) {
    const loadRrmePackagePromises = offerGroups.map((offerGroup) =>
        loadRrmeOfferGroupFromApi(
            publicationId,
            log,
            offerGroup,
            isSSR,
            variant,
            config,
        ),
    )

    await Promise.allSettled(loadRrmePackagePromises)
}
